import React, { useEffect, useRef, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import ElectronicPaymentReceipt from "../../components/electronicPayment/PDF/ElectronicPaymentReceipt";
import RealEstateTaxPaymentReceipt from "../../components/electronicPayment/PDF/RealEstateTaxPaymentReceipt";
import MainContent from "../../layouts/maincontent/MainContent";
import * as htmlToImage from "html-to-image";
import { jsPDF } from "jspdf";
import styles from "../taxDeclaration/listData/ListData.module.css";
import {
  getPaymentData,
  getPaymentReceipt,
} from "../../adapters/apis/lookups/lookups";
import { get } from "../../adapters/xhr/api";

function PDFReceipt() {
  const { id } = useParams();
  const printElectronic = useRef();
  const printRealEstateTax = useRef();
  const electronicPDF = printElectronic.current;
  const realEstateTaxPDF = printRealEstateTax.current;
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    checkVerfication();
  }, []);

  const checkVerfication = async () => {
    try {
      const response = await get("api/user/verifications", {}, true);
      const isFullyVerified =
         response?.data?.phone_verified;
      if (!isFullyVerified) {
        navigate("/DisabledHome");
      }
    } catch (error) {
      console.log(error);
    }
  };
  //with htmlToImage
  useEffect(() => {
    getPaymentReceipt(id)
      .then((res) => {
        if (res.data.data.status != 2) {
          navigate("/not-found");
        }
        setData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status === 404) {
          navigate("/not-found");
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleDownloadPdf = async () => {
    await htmlToImage
      .toPng(electronicPDF, { quality: 0.95 })

      .then(function (dataUrl) {
        const pdf = new jsPDF();

        const imgProperties = pdf.getImageProperties(dataUrl);

        const pdfWidth = pdf.internal.pageSize.getWidth();

        const pdfHeight =
          (imgProperties.height * pdfWidth) / imgProperties.width;

        pdf.addImage(dataUrl, "PNG", 0, 0, pdfWidth, pdfHeight);

        //pdf.save(`${new Date().toISOString()}.pdf`);
        pdf.save(`إيصال السداد الإلكتروني.pdf`);
      });
    await htmlToImage
      .toPng(realEstateTaxPDF, { quality: 0.95 })

      .then(function (dataUrl) {
        const pdf = new jsPDF();

        const imgProperties = pdf.getImageProperties(dataUrl);

        const pdfWidth = pdf.internal.pageSize.getWidth();

        const pdfHeight =
          (imgProperties.height * pdfWidth) / imgProperties.width;

        pdf.addImage(dataUrl, "PNG", 0, 0, pdfWidth, pdfHeight);

        //pdf.save(`${new Date().toISOString()}.pdf`);
        pdf.save(`إيصال سداد الضريبة العقارية.pdf`);
      });
  };
  return (
    <MainContent>
      <section
        className={`${styles.listData} ${styles["list-payment"]} list-payment`}
      >
        <div className="container pt-4">
          <div className={styles.box}>
            <div className={`${styles["box-header"]}`}>
              <h3 className={`${styles["box-title"]} mb-0`}>تحميل الايصالات</h3>
              <div className={styles["btns-header"]}>
                <button
                  type="button"
                  onClick={handleDownloadPdf}
                  className={styles["btns-header-order"]}
                >
                  تحميل PDF
                </button>
              </div>
            </div>
            <div className={`${styles["box-body"]} mt-3`}>
              <div className={`${styles["box-body-content"]} pt-0`}>
                <div ref={printElectronic} className="p-lg-5 m-lg-5">
                  <ElectronicPaymentReceipt data={data} />
                </div>
                <div ref={printRealEstateTax} className="p-lg-5 m-lg-5">
                  <RealEstateTaxPaymentReceipt data={data} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </MainContent>
  );
}

export default PDFReceipt;
